// Vendors
import { useSelector } from "react-redux";
import { RootState } from "store";
import { BodyFull } from "./BodyFull";

export const PDFLaborOldFull: React.FC = () => {
  const certificates = useSelector(
    (state: RootState) => state.ordsReducer.certificates
  );

  return (
    <>
      <BodyFull data={certificates} />
    </>
  );
};
